import escape from 'lodash/escape'

interface CopyLinkToClipboardParams {
  url: string
  formattedText?: string
}

/**
 * @deprecated Use `copyLinkToClipboard` instead. It reports whether the copy succeeded, keeps line
 * breaks (the temporary input below strips them) and doesn't steal the focus from the page.
 */
export const copyToClipboard = (value: string): void => {
  const tempInput = document.createElement('input')
  tempInput.value = value
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
}

export const copyLinkToClipboard = async ({ url, formattedText }: CopyLinkToClipboardParams) => {
  const plainText = formattedText ? `[${formattedText}](${url})` : url

  if (formattedText && typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    const html = `<a href="${escape(url)}">${escape(formattedText)}</a>`

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plainText], { type: 'text/plain' }),
        }),
      ])

      return true
    } catch {}
  }

  try {
    await navigator.clipboard.writeText(plainText)
    return true
  } catch {
    return false
  }
}
